import { supabase } from "@/integrations/supabase/client";

export const getPlanRoutines = async (planId: string) => {
  console.log("Fetching routines for workout plan:", planId);

  try {
    // First get the routine IDs + position from workout_plan_routines
    const { data: routineLinks, error: linksError } = await supabase
      .from('workout_plan_routines')
      .select('routine_id, position')
      .eq('workout_plan_id', planId)
      .order('position', { ascending: true });

    if (linksError) {
      console.error("Error fetching routine links:", linksError);
      throw linksError;
    }

    if (!routineLinks?.length) {
      console.log("No routines found for plan");
      return [];
    }

    const routineIds = routineLinks.map(link => link.routine_id);
    const positionMap = new Map(routineLinks.map(link => [link.routine_id, link.position ?? 0]));

    // Then get the full routine data including exercises (with position so we can sort)
    const { data: routines, error: routinesError } = await supabase
      .from('routines')
      .select(`
        id,
        name,
        exercises (
          id,
          name,
          sets,
          reps,
          weight,
          set_data,
          position
        )
      `)
      .in('id', routineIds);

    if (routinesError) {
      console.error("Error fetching routines:", routinesError);
      throw routinesError;
    }

    // Sort routines by plan position and exercises by exercise position
    const sorted = (routines || [])
      .map(r => ({
        ...r,
        plan_position: positionMap.get(r.id) ?? 0,
        exercises: (r.exercises || []).slice().sort(
          (a: any, b: any) => (a.position ?? 0) - (b.position ?? 0)
        ),
      }))
      .sort((a, b) => (a.plan_position ?? 0) - (b.plan_position ?? 0));

    console.log("Successfully fetched routines (sorted):", sorted);
    return sorted;
  } catch (error) {
    console.error("Error in getPlanRoutines:", error);
    throw error;
  }
};
